<template>
  <div class="home">
    <!--头部-->
    <XDheader></XDheader>
    <div class="container">
      <!-- 报名 -->
      <div class="row">
        <div class="col-md-9">
          <XDswiper></XDswiper>
        </div>
        <div class="col-md-3">
          <div class="itemimg">
            <ul>
              <!-- <li
								@click="gotopath(gameId+'/sign', '立即报名')"
								style="background:#e67e22 url('https://scdn.xidong360.com/longhu-marathon/2019/0816/home/sign.png');"
              ></li>-->
              <li
                style="background:#e67e22 url('https://scdn.xidong360.com/longhu-marathon/2019/0816/home/sign.png');cursor:pointer"
                @click="show()"
              ></li>
              <li
								@click="gotopath(gameId+'/sign/signquery', '报名查询')"
								style="background:#1b6ce1 url('https://scdn.xidong360.com/longhu-marathon/2019/0816/home/sign-select.png');"
							>
              </li>
              <!-- <li
                style="background:#1b6ce1 url('https://scdn.xidong360.com/longhu-marathon/2019/0816/home/sign-select.png');"
              ></li> -->
              <li
                @click="gotopath(gameId+'/pics/精彩图集', '精彩图集')"
                style="background:#1b6ce1 url('https://scdn.xidong360.com/longhu-marathon/2019/0816/home/show.png');"
              ></li>
              <li
                v-if="!match.scoreurl"
								@click="gotopath(gameId+'/score/scorequery', '成绩查询')"
								style="background:#1b6ce1 url('https://scdn.xidong360.com/longhu-marathon/2019/0816/home/select.png');"
							>
              </li>
              <li
                v-if="match.scoreurl"
                style="background:#1b6ce1 url('https://scdn.xidong360.com/longhu-marathon/2019/0816/home/select.png');"
              ><a style="width:100%;height:100%;display:inline-block;" :href="match.scoreurl" target="b_blank"></a></li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 倒计时 -->
      <div class="row time themes_news_title_1">
        <div class="col-md-4" style="font-size:36px;border-right:5px solid #fff;">比赛倒计时</div>
        <div class="col-md-8">
          <XDcountdown></XDcountdown>
        </div>
      </div>
      <!--新闻列表以及详情  -->
      <div class="row">
        <div class="col-md-8" style="padding-right:30px;">
          <div class="news">
            <!-- 新闻标题 -->
            <div class="title themes_partner_name_1">
              <div class="news_title" style="text-align:left;">
                <span
                  class="themes_menu_wrap_1"
                  style="display: inline-block;width: 5px;margin-top:5px;height: 35px;margin-bottom:-5px;"
                ></span>
                <i class="el-icon-tickets" style="margin:0 5px;"></i>
                赛事动态
              </div>
            </div>
            <div class="content">
              <!-- 跳转到指定图文页面 -->
              <!-- 显示前三条数据 -->
              <div
                class="row item"
                v-show="i<=2"
                v-for="(item,i) in news"
                :key="i"
                @click="shownews(item.uuid)"
              >
                <!-- 新闻 -->
                <div class="date themes_countdown_1 col-md-2 themes_news_title_1" v-bind:class="themes_news_date">
                  <span
                    class="dd"
                    style="font-size:45px;"
                  >{{ new Date(item.createtime) | moment("DD") }}</span>
                  <span class="mm"  style="font-size:12px;">{{ new Date(item.createtime) | moment("YYYY-MM") }}</span>
                </div>
                <div class="ntitle col-md-10" v-bind:class="themes_news_name">
                  <p class="news_item_title themes_partner_name_1">{{item.title}}</p>
                  <p style>{{item.summary?item.summary:item.title}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="match-info themes_partner_name_1">
            <div class="news_title">
              <span
                class="themes_menu_wrap_1"
                style="display: inline-block;width: 5px;margin-top:5px;height: 35px;margin-bottom:-5px;"
              ></span>
              <i class="el-icon-tickets" style="margin:0 5px;"></i>
              赛事地点
            </div>
          </div>
          <div class="match-info-content">
            <!-- 暂代日程图 -->
            <div style="width:100%;height:300px;" id="map">
              <!-- <a :href="gotoMap()" target="_blank"><img src="../../assets/img/map.png" alt="" style="width:100%;"></a> -->
            </div>
          </div>
        </div>
      </div>

      <!--功能区-->
      <div class="row fun-wrap">
        <div class="funs" v-for="fun in functions" :key="fun.func" style="width:25%;">
          <!-- <div class="guicheng" )"> -->
          <div
            class="fun"
            :style="{'background': fun.bgColor }"
            v-bind:class="themes_media_func"
            @click="gotopath('/' + gameId + '/func/'+fun.func, fun.func)"
          >
            <h4 style="margin:0">{{fun.func}}</h4>
          </div>
        </div>
      </div>

      <!--媒体合作伙伴区-->
      <div class="row">
        <XDmediaPartner></XDmediaPartner>
      </div>
    </div>
    <!-- </div> -->

    <XDfooter></XDfooter>
    <div id="code" style="display:none;">
      <img :src="this.match.xcxurl" id="qs" style="width:100%;" alt />
	  <i class="el-icon-close" @click="hide" style="font-size:28px;position :absolute;right:15px;top:10px;cursor:pointer;"></i>
	  <p style='text-align:center;margin-top:5px;'>扫描上方二维码，进入报名</p>
    </div>
  </div>
</template>
<script>
import api from "@/axios";
import { mapState, mapGetters } from "vuex";
import _ from "underscore";
export default {
  data() {
    return {
      sliderImg: 1,
      swiperOptionTop: {
        spaceBetween: 10,
        loop: true,
        loopedSlides: 5, //looped slides should be the same
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        observeParents: true,
        observer: true
      },
      swiperOptionThumbs: {
        spaceBetween: 10,
        slidesPerView: 4,
        touchRatio: 0.2,
        loop: true,
        loopedSlides: 5, //looped slides should be the same
        slideToClickedSlide: true,
        observeParents: true,
        observer: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      news: [],
      swiperSliders: [],
      New: [1, 2, 3],
      functions: [
        {
          bgColor: "#F47920",
          func: "参赛须知"
        },
        {
          bgColor: "#FFDD00",
          func: "官方活动"
        },
        {
          bgColor: "#009245",
          func: "参赛指南"
        },
        {
          bgColor: "#A4CC4F",
          func: "招商指南"
        }
      ],
      qrCodeUrl: "  ", //扫描二维码之后跳转的页面,
      imgUrl: "" //二维码
    };
  },
  mounted() {
    // 倒计时
    this.getnews();
  this.showMap(this.match);
  console.log(this.match);
  
  },
  methods: {
    gotoMap() {
      return `https://uri.amap.com/marker?name=${this.match.name}&&position=${this.match.longitude},${this.match.latitude}`;
    },
    gotopath(path, menuname) {
      this.$router.push({ path });
      this.$store.dispatch("SetMenuName", menuname);
    },
    goto(path) {
      if (path) {
        window.location.href = path;
      }
    },
    shownews(uuid) {
      var newinfo = _.findWhere(this.news, { uuid });
      if (newinfo) {
        if (newinfo.from == 2) {
          window.open(newinfo.link, "_blank");
        } else {
          this.$router.push({
            path: "/" + this.gameId + "/content/" + uuid
          });
        }
      }
    },
    getnews() {
      api.homenews({ gameId: this.gameId }).then(({ data }) => {
		  console.log(data);

        if (data.code === 0) {
          this.news = data.data;
          for (var i = 0; i < this.news.length; i++) {
            if (this.news[i].cover) {
              this.swiperSliders.push(this.news[i]);
            }
          }
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    showMap(coords) {
      var myLatAndLong = new qq.maps.LatLng(coords.latitude, coords.longitude);
      var map = $("#map");
      map = new qq.maps.Map(document.getElementById("map"), {
        center: myLatAndLong,
        zoom: 13,
        draggable: true,
        scrollwheel: true,
        disableDoubleClickZoom: false,
        disableDefaultUI: true
      });
    },
    show() {
      $("#code").css("display", "block");
	},
	hide(){
		 $("#code").css("display", "none");
	}
  },
  computed: {
	...mapState(["appweb", "gameId", "match"]),


    themes_countdown: function() {
      return "themes_countdown_" + this.$store.state.appweb.themetype;
    },
    themes_media_func: function() {
      return "themes_media_func_" + this.$store.state.appweb.themetype;
    },
    themes_partner_name: function() {
      return "themes_partner_name_" + this.$store.state.appweb.themetype;
    },
    themes_news_title: function() {
      return "themes_news_title_" + this.$store.state.appweb.themetype;
    },
    themes_news_date: function() {
      return "themes_news_date_" + this.$store.state.appweb.themetype;
    },
    themes_news_name: function() {
      return "themes_news_name_" + this.$store.state.appweb.themetype;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.xcxQR-wrap {
  display: flex;
  justify-content: left;
  align-items: center;
}
.xcxQR {
  width: 100px;
  height: 100px;
}
.mathch-tip {
  padding-left: 15px;
}
.match-info-content {
  color: #999;
}
.match-info {
  background-color: #fff;
  /* border: 6px solid #007bff; */
  /* background-color: transprent; */
  padding: 10px;
  margin: 10px 0px;
}
.match-info-title {
  font-size: 20px;
  font-weight: 600;
}

.fun-wrap {
  margin: 0px -15px 0 0 !important;
  background: url(/img/fun_img.jpg);
  justify-content: center;
  align-items: center;
}

.row {
  margin: 10px -1px;
  background: #fff;
}
.fun {
  border-radius: 5px;
  padding: 46px 8px;
  text-align: center;
  cursor: pointer;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.fun-wrap .funs {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.fun-wrap .funs .fun {
  width: 95%;
  color: #fff;
}
.news .title {
  border-radius: 5px;
}
.news .item {
  background: #eee;
  margin: 6px 0;
  cursor: pointer;
  display: flex;
}
.news .item[data-v-957c9522] {
  border-radius: 5px;
}
.news .item .date {
  text-align: center;
  padding: 0px 10px;
}
.news .item .date span {
  display: block;
}
.news .item .date span.dd {
  font-size: 30px;
  font-weight: bold;
}
.news .item .date span.mm {
  font-size: 15px;
}
.news .item .ntitle {
  padding: 23px 0;
  font-size: 14px;
}
div.title {
  padding: 20px 8px;
}
div.title span {
  font-size: 16px;
}
.news .item .col-md-3,
.col-md-4 {
  padding: 0;
}
.time {
  border-radius: 5px;
  background: #1b6ce1;
  color: #fff;
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 18px;
}
.countdownTitle {
  padding: 10px;
}
.container {
  padding: 0;
}
.swiper-container {
  background-color: #000;
}
.swiper-slide {
  background-size: cover;
  background-position: center;
}
.slide {
  height: 330px;
}
.gallery-top {
  height: 70% !important;
  width: 100%;
}
.gallery-thumbs {
  height: 30% !important;
  box-sizing: border-box;
  padding: 10px 0;
}
.gallery-thumbs .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}
.gallery-thumbs .swiper-slide-active {
  opacity: 1;
}
.time[data-v-957c9522] {
  border-radius: 5px;
}
.gallery-top[data-v-957c9522] {
  border-radius: 5px 5px 0px 0px;
}
.gallery-thumbs[data-v-957c9522] {
  border-radius: 0px 0px 5px 5px;
}
.match-line .wrap {
  height: 241px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.ad-01 {
  height: 100%;
  margin-left: -15px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

/* banner模块中的操作 */
.itemimg,
.itemimg ul {
  height: 100%;
  padding: 0;
}
.itemimg ul {
  padding-left: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.itemimg ul li {
  height: 23%;
  background-size: 50% !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
  border-radius: 5px;
  cursor: pointer;
  
}
.col-md-3,
.col-md-9,
.col-md-4,
.col-md-8 {
  padding: 0;
}

/* 新闻列表 */
.news .title .news_title,
.col-md-4 .news_title {
  font-size: 26px;
  border-bottom: 2px solid #007bff;
}
.news .content .item {
  height: 100px;
  /* justify-content: flex-start; */
}
.news .content .item .date {
  height: 100%;
  width: 100px;
}
.news .content .item .ntitle {
  padding: 10px;
}
.news .content .item .ntitle .news_item_title {
  font-size: 18px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  margin-bottom: 5px;
  text-align: left;
}
.news .content .item .ntitle .news_item_title:hover {
  color: #e67e22;
}
.news .content .item .ntitle p {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  margin-bottom: 0;
}
#code {
  width: 400px;
  height: 400px;
  position: fixed;
  left: 50%;
  top: 20%;
  transform: translate(-50%);
  background-color: #fff;
  z-index: 999;
  padding: 30px;
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/template/home/1-home.vue